<section class="px-0.5">
    <div class="flex-between-center flex-wrap gap-4">
        <div class="flex-start-center gap-x-3 filter-btn-group overflow-x-auto p-0.5">
            <button nz-button [disabled]="loading" [class.active]="queryParams.type === 'all'" (click)="changeFilterType('all')">
                All
                <span *ngIf="queryParams.type === 'all' && !loading"> ({{(total || 0) | kmb2:2}})</span>
            </button>
            <button nz-button [disabled]="loading" [class.active]="queryParams.type === 'smart_buy'" (click)="changeFilterType('smart_buy')">
                Smart Buy
                <span *ngIf="queryParams.type === 'smart_buy' && !loading">(<span class="text-success">{{(total || 0) | kmb2:2}}</span>)</span>
            </button>
            <button nz-button [disabled]="loading" [class.active]="queryParams.type === 'smart_sell'" (click)="changeFilterType('smart_sell')">
                Smart Sell
                <span *ngIf="queryParams.type === 'smart_sell' && !loading">(<span class="text-error">{{(total || 0) | kmb2:2}}</span>)</span>
            </button>
            <button
                *ngIf="chainName !== 'sol'"
                nz-button
                [disabled]="loading"
                [class.active]="queryParams.type === 'top_holders'"
                (click)="changeFilterType('top_holders')"
            >
                Top Holder TX
                <span *ngIf="queryParams.type === 'top_holders' && !loading"> ({{(total || 0) | kmb2:2}})</span>
            </button>
        </div>

        <div class="flex-start-center gap-x-4">
            <a class="md:hidden !pb-0" nz-button nzSize="small" [href]="viewAllTxLink" target="_blank">
                View All TX
                <span nz-icon nzType="link"></span>
            </a>

            <nz-radio-group class="max-md:hidden" [disabled]="loading" [(ngModel)]="queryParams.timerange" (ngModelChange)="durationChange()">
                <label nz-radio-button *ngFor="let duration of durations" [nzValue]="duration">{{duration}}</label>
            </nz-radio-group>

            <nz-select class="md:hidden" [(ngModel)]="queryParams.timerange" [disabled]="loading" (ngModelChange)="durationChange()">
                <nz-option *ngFor="let duration of durations" [nzValue]="duration" [nzLabel]="duration"></nz-option>
            </nz-select>
        </div>
    </div>

    <div class="mt-5">
        <nz-table
            #trendingTable
            [nzData]="txns"
            nzTableLayout="fixed"
            [nzScroll]="{ x: '1000px' }"
            [nzFrontPagination]="false"
            [nzLoading]="loading"
            [nzShowPagination]="false"
        >
            <thead>
                <tr>
                    <th
                        *ngFor="let column of columns"
                        [nzWidth]="column.width"
                        [nzLeft]="column.fixed === 'left'"
                        [nzRight]="column.fixed === 'right'"
                        [nzColumnKey]="column.id"
                        [nzShowSort]="false"
                        [nzSortOrder]="column.sortOrder || column.combinedColumns?.[0]?.sortOrder || column.combinedColumns?.[1]?.sortOrder"
                    >
                        <app-socialscan-table-thead-th [column]="column" (filterChange)="applyFilter($event)"></app-socialscan-table-thead-th>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of trendingTable.data">
                    <td>
                        <div class="w-full flex-start-center gap-x-2">
                            <app-hexagon-img [imgUrl]="commonService.getAddressIcon(data.address)" class="w-8"></app-hexagon-img>

                            <div class="text-sm flex-1 min-w-0 space-y-1">
                                <div class="flex-start-center text-sm gap-x-1">
                                    <span class="cursor-pointer">{{data.address | address}}</span>
                                    <span
                                        nz-icon
                                        nzType="antd:v2-copy"
                                        class="hover:text-black text-sub-text text-sm !cursor-pointer"
                                        appCopy
                                        [copyText]="data.address"
                                    ></span>

                                    <img *ngIf="data.is_smart_money" nz-tooltip="Smart Money" src="/assets/imgs/icon/money.png" class="w-5 h-auto" alt="" />

                                    <img *ngIf="data.is_whale" nz-tooltip="Whale" src="/assets/imgs/icon/whale.png" class="w-5 h-auto" alt="" />
                                </div>
                                <div class="text-xs text-sub-text flex-start-center gap-x-1 w-full h-[22px]">
                                    <!-- 非编辑状态 -->
                                    <ng-container *ngIf="!isEditing(data.address)">
                                        <div *ngIf="data.label" class="text-[#FF8811] min-w-0 truncate max-w-fit">{{data.label}}</div>
                                        <span nz-icon nzType="antd:v2-edit" class="hover:text-black text-sm !cursor-pointer" (click)="startEdit(data)"></span>
                                    </ng-container>

                                    <!-- 编辑状态 -->
                                    <ng-container *ngIf="isEditing(data.address)">
                                        <nz-input-group [nzSuffix]="inputButtons" class="flex-1 !h-[22px] !px-1 !py-0 !rounded">
                                            <input
                                                nz-input
                                                [ngModel]="getEditingNote(data.address)"
                                                (ngModelChange)="setEditingNote(data.address, $event)"
                                                class="!text-sm !rounded-none"
                                            />
                                        </nz-input-group>
                                        <ng-template #inputButtons>
                                            <div class="flex-center-center gap-x-1 text-2xs">
                                                <div class="w-3 h-3 bg-secondaryCard rounded-sm flex-center-center hover:bg-black hover:text-white">
                                                    <span
                                                        nz-icon
                                                        [nzType]="savingNotesAddresses.includes(data.address)  ? 'loading' : 'check'"
                                                        class="!cursor-pointer"
                                                        (click)="saveNotes(data.address)"
                                                    ></span>
                                                </div>
                                                <div
                                                    class="w-3 h-3 bg-secondaryCard rounded-sm flex-center-center hover:bg-black hover:text-white"
                                                    (click)="stopEdit(data.address)"
                                                >
                                                    <span nz-icon nzType="close" class="!cursor-pointer"></span>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </td>

                    <td>
                        <div *ngIf="data.type === 'buy'" class="text-success">Buy</div>
                        <div *ngIf="data.type === 'sell'" class="text-error">Sell</div>
                    </td>

                    <td>${{data.amount_usd|kmb2:2}}</td>
                    <td>{{data.amount|kmb2:2:true}}</td>
                    <td>${{formatDecimalPart(data.price || 0)}}</td>

                    <td>
                        <div class="mb-1">{{ageMap[data.block_timestamp]}}</div>
                        <div class="text-xs text-sub-text">{{data.block_timestamp| date:'MM/dd HH:mm'}}</div>
                    </td>
                </tr>
            </tbody>
        </nz-table>

        <div *ngIf="trendingTable.data && queryParams.last_block_timestamp" class="flex-center-center gap-x-2 mt-6 mb-5">
            <button nz-button nzType="primary" (click)="fetchData(true)" [nzLoading]="loading">Load More</button>
        </div>
    </div>
</section>
